import { isPlatform } from '@ionic/vue';
import router from '@/router';

export const isMobileDevice = () => {
  if (isPlatform('mobileweb') || isPlatform('desktop')) {
    return false;
  } else {
    return true;
  }
}

export const goBackToMembershipCard = () => {
  if (import.meta.env.VITE_ENV == 'staging') {
    window.location.href = 'native:/tab/atom/d453b7b1?page_id=01J7J4XBN5HP1NW5Q15M248E13&type=basic';
  } else {
    window.location.href = 'native:/tab/redirect/3b2d274f';
  }
}

export const goToLoginPage = () => {
  window.location.href = 'native:/tab/atom/52ad0d1d?page_id=01JB19JABNXCZDM51ZTVZ2MZMB&type=basic';
}

export const goToCouponPage = () => {
  if (import.meta.env.VITE_ENV == 'staging') {
    window.location.href = 'native:/tab/coupon/83e40439?id=1';
  } else {
    window.location.href = 'native:/tab/coupon/10ccaa26?id=6';
  }
}

export const goToCouponTab = () => {
  if (import.meta.env.VITE_ENV == 'staging') {
    window.location.href = 'native:/tab/scrollmenu/89138edb';
  } else if (import.meta.env.VITE_ENV == 'production') {
    window.location.href = 'native:/tab/scrollmenu/2462adc2';
  } else {
    router.push({ name: 'StoreCoupons' });
  }
}